import type {Batch, BatchSupplier, ReturnedBatch} from '@/types/batch-types'
import type { AxiosResponse } from "axios";

import api from '@/axios'

export const getBatchList = async (): Promise<Batch[]> => {
  const response = await api.get("/batches");
  return response.data;
}

export const getReturnedBatchList = async (): Promise<ReturnedBatch[]> => {
  const response = await api.get("/batches/returned");
  return response.data;
}
export const getReturnedBatchById = async (id: string): Promise<ReturnedBatch> => {
  const response = await api.get(`/batches/returned/${id}`);
  return response.data;
}

export const getBatchById = async (id: string): Promise<Batch> => {
  const response = await api.get(`/batches/${id}`);
  return response.data;
}

export const addBatch = async (batch: any): Promise<Batch> => {
  const response = await api.post('/batches', batch);
  return response.data;
}

export const editBatch = async (batch: Batch, id: string): Promise<AxiosResponse> => {
  const response = await api.patch(`/batches/${id}`, batch);
  return response.data;
}

export const sendToSupplier = async ( batch: BatchSupplier) : Promise<AxiosResponse> => {
  const response = await api.post(`/batches/send-to-supplier`, batch);
  return response.data;
}

export const returnFromSupplier = async(batch: any, batchId: string) : Promise<AxiosResponse> => {
  const response = await api.post(`/batches/return-from-supplier/${batchId}`, batch);
  return response.data;
}

export const createBatchPackingList = async (packingList : any) : Promise<any> => {
  const response = await api.post(`/batches/packing-lists`, packingList);
  return response.data;
}

export const addQualityCheck = async (qualityCheck : any) : Promise<any> => {
  const response = await api.post(`/batches/quality-check`, qualityCheck);
  return response.data;
}
export const addFireTest = async (formData: FormData) => {
  const response = await api.post('/batches/fire-test', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateFireTest = async (fireTestId: string, formData: FormData) => {
  const response = await api.put(`/batches/fire-test/${fireTestId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};


export const getFireTestCertificate = async (fireTestId: string): Promise<Blob> => {
  const response = await api.get(`/batches/fire-test/${fireTestId}/certificate`, {
    responseType: 'blob'
  });
  return response.data;
}

export const getAvailableBatches = async () : Promise<any> => {
  const response = await api.get(`/batches/available`);
  return response.data;
}

export const getDispatchedBatches = async () : Promise<any> => {
  const response = await api.get(`/batches/dispatched`);
  return response.data;
}

export const getMachineNumbers = async (): Promise<string[]> => {
  const response = await api.get('/batches/machine-numbers')
  return response.data
}

export const getBatchHistory = async (batchId: string) => {
    const response = await api.get(`/batches/${batchId}/history`)
    return response.data
}

export const getBatchSnapshot = async (batchId: string, milestone: string) => {
    const response = await api.get(`/batches/${batchId}/snapshot/${milestone}`)
    return response.data
}

export const findReturnedBatchByRollId = async (returnedRollId: string): Promise<ReturnedBatch | null> => {
  try {
    const returnedBatches = await getReturnedBatchList();

    for (const batch of returnedBatches) {
      const foundRoll = batch.returnedRolls?.find(roll => roll.id === returnedRollId);
      if (foundRoll) {
        return batch;
      }
    }

    return null;
  } catch (error) {
    console.error('Error finding returned batch by roll ID:', error);
    return null;
  }
}